module.exports = __webpack_public_path__ + "img/pic3.14a94faa.png";